'use client';

import React, { useState } from 'react';

import { css, cx } from '@pt-group-fe/styled-system/css';
import { Flex, Grid, GridItem } from '@pt-group-fe/styled-system/jsx';
import { cmsContentContactForm } from '@pt-group-fe/styled-system/recipes';

import { Cms_ContentContactForm } from '@lib/services/cms';
import { SmtpConfig } from '@lib/services/contact';
import { CmsEditorText } from '@lib/ui/cmsEditorText';
import { Icon } from '@lib/ui/icon';
import { Img } from '@lib/ui/img';
import { Text } from '@lib/ui/text';

import ContactFormInner from './ContactFormInner';

// const ContactFormInner = React.lazy(() => import('./ContactFormInner'));
const ContactFormTermsDialog = React.lazy(() => import('./ContactFormTermsDialog'));

interface ContactFormProps {
  data: Cms_ContentContactForm;
  formId: string;
  hasCaptcha?: boolean;
  smtpConfig?: SmtpConfig;
  userEmail?: string;
  userCompany?: string;
  userName?: string;
}

const ContactForm: React.FC<ContactFormProps> = props => {
  //  const { ref, isVisible } = useIsVisible();
  const { data, formId } = props;
  const { containerInner, imgBox, infoIcon, infoText, gridItem, gridItemAddr } =
    cmsContentContactForm();
  const [isTermsOpen, setTermsOpen] = useState(false);
  const isTermsEnabled = data.terms && data.terms.checkboxLabel && data.terms.content;

  return (
    <>
      <Grid gap={8} columns={{ base: 1, lg: 2 }} className={containerInner}>
        <GridItem id={formId} className={cx(gridItem, css({ minH: 400 }))} /* ref={ref} */>
          {/*    {isVisible && ( */}
          <ContactFormInner {...props} isTermsOpen={isTermsOpen} setTermsOpen={setTermsOpen} />
          {/*    )} */}
        </GridItem>

        {data.address && (
          <GridItem className={gridItemAddr}>
            <div className={imgBox}>
              <Img
                fill
                data={data.address.image}
                alt={data.title}
                sizes={{ _: 100, lg: 75, xl: 50, '2xl': 40, '3xl': 30, '4xl': 25 }}
              />
            </div>
            <Flex flexDir="column" gap={6} px={8} py={12}>
              <Flex gap={8}>
                <Icon i="pin-location" className={infoIcon} />
                <CmsEditorText data={data.address.address} variant="blockLg" className={infoText} />
              </Flex>
              <Flex gap={8}>
                <Icon i="phone" className={infoIcon} />
                <Text variant="block" className={infoText}>
                  <a href={`tel:${data.address.phone}`}>{data.address.phone}</a>
                </Text>
              </Flex>
              <Flex gap={8}>
                <Icon i="envelope" className={infoIcon} />
                <Text variant="block" className={infoText}>
                  <a href={`mailto:${data.address.email}`}>{data.address.email}</a>
                </Text>
              </Flex>
            </Flex>
          </GridItem>
        )}
      </Grid>

      {isTermsEnabled && isTermsOpen && data.terms?.content && (
        <ContactFormTermsDialog
          data={data.terms?.content}
          isOpen={isTermsOpen}
          setOpen={setTermsOpen}
        />
      )}
    </>
  );
};

export { ContactForm };
export type { ContactFormProps };
